// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Country } from './country';
import { Equipment } from './equipment';
import { SalesTransaction } from './sales-transaction';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class Customer extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  customerId: number;
  applicationUserId: string;
  countryId: number;
  createdOn: Date;
  customerLoctaion: string;
  customerMobile: string;
  customerName: string;
  customerPhone: string;
  modifiedOn: Date;
  website: string;
  applicationUser: ApplicationUser;
  country: Country;
  equipments: Equipment[];
  salesTransactions: SalesTransaction[];
}

